import React, { useState, lazy, Suspense } from "react";
import Navigation from "./components/Navigation";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
// Lazy-loaded components
const Section1 = lazy(() => import("./sections/Section1"));
const Section2 = lazy(() => import("./sections/Section2"));
const Section3 = lazy(() => import("./sections/Section3"));
const Section4 = lazy(() => import("./sections/Section4"));
const Section5 = lazy(() => import("./sections/Section5"));
const Section6 = lazy(() => import("./sections/Section6"));
const Section7 = lazy(() => import("./sections/Section7"));
const Section8 = lazy(() => import("./sections/Section8"));
const Section9 = lazy(() => import("./sections/Section9"));
const Section10 = lazy(() => import("./sections/Section10"));
const ThankYou = lazy(() => import("./sections/ThankYou"));

function App() {
  const [nav_height, setnav_height] = useState(0);
  const [Thank, setThank] = useState(false);

  return (
    <>
      <style>{`:root{--nav_height:${nav_height}px}`}</style>
      <Navigation {...{ setnav_height }} />
      <Suspense fallback={<div>Loading...</div>}>
        <Section1 />
        <Section2 />
        <Section3 />
        {/* <Section4 /> */}
        <Section5 />
        <Section6 />
        <Section7 />
        <Section8 />
        <Section9 />
        <Section10 setThank={setThank} />
        {Thank && <ThankYou setThank={setThank} />}
      </Suspense>
      <img
        src="https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/contactUs/Frame%201437254250.svg"
        style={{ width: "100%" }}
        className="show_desktop"
      />
      <img
        src="https://modernizingtrends.blr1.cdn.digitaloceanspaces.com/Lunos/mobile/footer123.svg"
        style={{ width: "100%" }}
        className="show_mobile"
      />

    </>
  );
}

export default App;
